import React, { useEffect, useState } from 'react'

import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { selectActionSheet } from '@selectors'

import { HIDE_ACTION_SHEET } from '@redux/actions/types'
import { SAFEWALK_SET_DATA } from '@actions/types'

import {
  Paragraph,
  ActionSheet,
  Button,
  Input
} from '@omnilert/components'

import { Formik, Form } from 'formik'

import { SAFEWALK_CUSTOM_DURATION_TEXT } from '@assets/i18n/strings'

import dayjs from 'dayjs'

import * as Yup from 'yup'

import useStyles from './safewalk-action-sheet.style'

import i18n from 'i18n-js'

const SafeWalkActionSheet = props => {
  const actionSheet = useSelector(selectActionSheet)
  const isVisible = actionSheet === 'SAFEWALKWALK'

  const classes = useStyles({ ...props, isVisible })

  const [showOtherInput, setShowOtherInput] = useState(false)

  const dispatch = useDispatch()

  const SAFEWALKWALK_DATA = [
    {
      label: '15 minutes',
      hours: 0,
      minutes: 15
    },
    {
      label: '30 minutes',
      hours: 0,
      minutes: 30
    },
    {
      label: '1 hour',
      hours: 1,
      minutes: 0
    },
    {
      label: '2 hours',
      hours: 2,
      minutes: 0
    },
    {
      label: 'other',
      hours: 0,
      minutes: 0
    }
  ]

  useEffect(() => {
    if (!isVisible) {
      setShowOtherInput(false)
    }
  }, [isVisible])

  const onClick = ({ hours, minutes, label }) => {
    if (label === 'other') {
      setShowOtherInput(true)
    } else {
      dispatch({
        type: SAFEWALK_SET_DATA,
        payload: {
          formDuration: dayjs.duration({ hours, minutes }).asMilliseconds()
        }
      })
      dispatch({ type: HIDE_ACTION_SHEET })
      setShowOtherInput(false)
    }
  }

  const handleOnCloseActionSheet = () => dispatch({ type: HIDE_ACTION_SHEET })

  const onSubmitDuration = ({ hours, minutes }) => {
    dispatch({
      type: SAFEWALK_SET_DATA,
      payload: {
        formDuration: dayjs.duration({ hours, minutes }).asMilliseconds()
      }
    })
    dispatch({ type: HIDE_ACTION_SHEET })
    setShowOtherInput(false)
  }

  const otherSchema = Yup.object().shape({
    minutes: Yup.number().when('hours', {
      is: (value) => !!value,
      then: (schema) => schema.max(59),
      otherwise: (schema) => schema.max(59).required('no')
    }),
    hours: Yup.number().when('minutes', {
      is: (value) => !!value,
      then: (schema) => schema.max(23),
      otherwise: (schema) => schema.max(23).required('no')
    })
  }, ['minutes', 'hours'])

  return (
    <ActionSheet
      className={classes.actionSheet}
      onClose={handleOnCloseActionSheet}
      show={isVisible}
    >
      {showOtherInput ? (
        <>
          <Formik
            initialValues={{ minutes: undefined, hours: undefined }}
            onSubmit={onSubmitDuration}
            validateOnBlur={false}
            validateOnChange
            validationSchema={otherSchema}
          >
            {({ values, errors, handleSubmit, handleChange }) => (
              <Form
                className={classes.otherForm}
                onSubmit={handleSubmit}
              >
                <Paragraph
                  className={classes.text}
                  color='var(--resource__description__text)'
                  size='lg'
                >
                  {i18n.t(SAFEWALK_CUSTOM_DURATION_TEXT)}
                </Paragraph>
                <div className={classes.formInputs}>
                  <Input
                    borderColor='var(--input__border)'
                    className={classes.input}
                    errorMessage={!!errors.hours}
                    maxLength={2}
                    name='hours'
                    onChange={handleChange}
                    placeholder='Hours'
                    size='lg'
                    type='numberPad'
                    value={values.hours || ''}
                  />
                  <Input
                    borderColor='var(--input__border)'
                    className={classes.input}
                    errorMessage={!!errors.minutes}
                    maxLength={2}
                    name='minutes'
                    onChange={handleChange}
                    placeholder='Minutes'
                    size='lg'
                    type='numberPad'
                    value={values.minutes || ''}
                  />
                </div>
                <Button
                  className={classes.buttonSubmit}
                  disabled={!!Object.keys(errors)?.length}
                  fullWidth
                  size='lg'
                  title='Update duration'
                  titleClassName={classes.otherSubmitButtonTitle}
                  type='submit'
                  variant='solid'
                />
              </Form>
            )}
          </Formik>
        </>
      ) : (
        <ul className={classes.list}>
          {SAFEWALKWALK_DATA.map((data, index) => (
            <li
              key={`safewalk${index}`}
              className={classes.actionItem}
              onClick={e => onClick(data)}
            >
              <div className={classes.textContainer}>
                <div className={classes.labelText}>{data.label}</div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </ActionSheet>
  )
}

SafeWalkActionSheet.defaultProps = {
  isVisible: false
}

SafeWalkActionSheet.propTypes = {
  isVisible: PropTypes.bool
}

export default SafeWalkActionSheet
